import * as actionTypes from './actionTypes';

export const updateUserBalance=(data)=>{
   return {
      type:actionTypes.UPDATE_USER_BALANCE,
      payload:data
   }
}